/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignVerticalSpaceAround = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2" }],
    ["path", { d: "M22 20H2" }],
    ["path", { d: "M22 4H2" }]
  ]
];

export { AlignVerticalSpaceAround as default };
//# sourceMappingURL=align-vertical-space-around.js.map
